const faqs = [
  {
    q: 'Como criar meu primeiro template?',
    a: 'Vá em Templates → Novo Template, escolha uma categoria e depois use o Designer para desenhar a etiqueta com precisío milimétrica.',
  },
  {
    q: 'Onde configuro as impressoras?',
    a: 'O módulo de Dispositivos conecta impressoras locais e de rede ao Print Agent instalado na estação de trabalho.',
  },
  {
    q: 'Como funciona a impressão em lote?',
    a: 'Na tela de impressão, preencha as variáveis e a quantidade. A numeração sequencial e a importação de CSV ficam disponíveis a partir da Fase de impressão Profissional.',
  },
  {
    q: 'Posso integrar com meu ERP?',
    a: 'Sim. A Documentação da API expõe os endpoints REST autenticados por JWT, escopados ao seu tenant.',
  },
];

export default function Help() {
  return (
    <div className="flex flex-col gap-base max-w-3xl">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Central de Ajuda</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Perguntas frequentes e orientações sobre o EtiquetandoApp Studio.
        </p>
      </div>

      <div className="bg-surface rounded-2xl shadow-sm overflow-hidden divide-y divide-surface-container-highest">
        {faqs.map((f) => (
          <details key={f.q} className="group px-6 py-4">
            <summary className="flex items-center justify-between cursor-pointer list-none font-semibold text-on-surface hover:text-primary transition-colors">
              {f.q}
              <span className="material-symbols-outlined text-on-surface-variant group-open:rotate-180 transition-transform">expand_more</span>
            </summary>
            <p className="mt-3 text-on-surface-variant font-body-md text-body-md">{f.a}</p>
          </details>
        ))}
      </div>

      <div className="flex items-center justify-between bg-primary-container rounded-2xl p-6">
        <div>
          <h3 className="studio-uniform-title font-h3 text-h3 text-on-primary-container">Precisa de mais ajuda?</h3>
          <p className="text-on-primary-container/80 text-[11px] mt-1">Nossa equipe responde em até 24h úteis.</p>
        </div>
        <button className="bg-primary text-on-primary font-label-sm text-label-sm px-6 py-3 rounded-lg shadow-md shadow-primary/20">
          Falar com suporte
        </button>
      </div>
    </div>
  );
}


